/* Acuity referral stamping (sitewide, first-touch) */
(function () {
  // ---------- CONFIG ----------
  const FORM_FIELD_ID   = "16380905";   // Acuity internal field id
  const PERSIST_DAYS    = 30;           // cookie/localStorage lifetime
  const USE_FIRST_TOUCH = true;         // true = first touch, false = last touch

  // Opt-out per page: add data-acuity-optout to <body>
  if (document.body && document.body.hasAttribute('data-acuity-optout')) return;

  // Which elements to stamp (works with Acuity embed buttons & iframes)
  const MAIN_BTN_SELECTOR = '.acuity-embed-button, #book-btn, [data-acuity-link]';
  const IFRAME_SELECTOR   = 'iframe[data-acuity-embed]';

  // ---------- UTILS ----------
  const Q  = new URLSearchParams(location.search);
  const lc = s => (s || '').toLowerCase();
  const get = k => (Q.get(k) || '').trim();
  function setCookie(name, value, days) {
    const d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
  }
  function getCookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function storeFirstTouch(val) {
    try {
      if (!localStorage.getItem('acuity_ref_source_first')) {
        localStorage.setItem('acuity_ref_source_first', val);
        localStorage.setItem('acuity_ref_first_ts', String(Date.now()));
      }
    } catch (e) {}
    if (!getCookie('acuity_ref_source_first')) setCookie('acuity_ref_source_first', val, PERSIST_DAYS);
  }
  function readFirstTouch() {
    try { const v = localStorage.getItem('acuity_ref_source_first'); if (v) return v; } catch (e) {}
    return getCookie('acuity_ref_source_first');
  }
  function storeLastTouch(val) {
    try { localStorage.setItem('acuity_ref_source_last', val); } catch (e) {}
    setCookie('acuity_ref_source_last', val, PERSIST_DAYS);
  }
  function readLastTouch() {
    try { const v = localStorage.getItem('acuity_ref_source_last'); if (v) return v; } catch (e) {}
    return getCookie('acuity_ref_source_last');
  }

  // ---------- CLASSIFICATION ----------
  const utm_source   = lc(get('utm_source'));
  const utm_medium   = lc(get('utm_medium'));
  const utm_campaign = lc(get('utm_campaign'));
  const srcAlias     = lc(get('src'));
  const gclid  = get('gclid'), fbclid = get('fbclid'), msclkid = get('msclkid'), ttclid = get('ttclid');

  let refHost = '';
  try { refHost = document.referrer ? (new URL(document.referrer)).hostname.replace(/^www\./, '').toLowerCase() : ''; } catch (e) {}

  const slug = s => lc(s).replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  const withCamp = base => utm_campaign ? `${base}_${slug(utm_campaign)}` : base;

  function classify() {
    // Manual override
    if (srcAlias) return withCamp(srcAlias);

    // Ad click IDs
    if (gclid)   return withCamp('google_ads');
    if (fbclid)  return withCamp('meta_ads');
    if (msclkid) return withCamp('microsoft_ads');
    if (ttclid)  return withCamp('tiktok_ads');

    // UTMs
    if (utm_medium) {
      if (utm_medium.includes('cpc') || utm_medium.includes('ppc') || utm_medium.includes('paid')) {
        if (utm_source.includes('google'))     return withCamp('google_ads');
        if (utm_source.includes('facebook') || utm_source.includes('instagram')) return withCamp('meta_ads');
        if (utm_source.includes('bing') || utm_source.includes('microsoft'))     return withCamp('microsoft_ads');
        if (utm_source.includes('tiktok'))     return withCamp('tiktok_ads');
        return withCamp(utm_source ? `${utm_source}_ads` : 'paid_ads');
      }
      if (utm_medium.includes('email'))     return withCamp('email');
      if (utm_medium.includes('sms'))       return withCamp('sms');
      if (utm_medium.includes('social')) {
        if (utm_source.includes('facebook') || utm_source.includes('instagram')) return withCamp('meta_social');
        if (utm_source.includes('tiktok'))  return withCamp('tiktok_social');
        if (utm_source.includes('twitter') || utm_source.includes('x')) return withCamp('twitter_social');
        return withCamp('social');
      }
      if (utm_medium.includes('referral'))  return withCamp(utm_source ? `${utm_source}_referral` : 'referral');
      if (utm_medium.includes('display'))   return withCamp('display');
      if (utm_medium.includes('affiliate')) return withCamp('affiliate');
    }

    if (utm_source) {
      if (utm_source.includes('google'))    return withCamp('google_organic');
      if (utm_source.includes('bing') || utm_source.includes('microsoft')) return withCamp('bing_organic');
      if (utm_source.includes('facebook') || utm_source.includes('instagram')) return withCamp('meta_social');
      if (utm_source.includes('tiktok'))    return withCamp('tiktok_social');
      if (utm_source.includes('email'))     return withCamp('email');
      return withCamp(utm_source);
    }

    // Referrer fallback
    if (refHost) {
      if (/google\./.test(refHost))                         return 'google_organic';
      if (/bing\.com|microsoft\./.test(refHost))            return 'bing_organic';
      if (/facebook\.com|instagram\.com/.test(refHost))     return 'meta_social';
      if (/tiktok\.com/.test(refHost))                      return 'tiktok_social';
      if (/t\.co|twitter\.com|x\.com/.test(refHost))        return 'twitter_social';
      if (/mail\.|outlook\.|gmail\.|yahoo\./.test(refHost)) return 'email';
      if (/alexandrasports\.com/.test(refHost))             return 'website';
      return `${refHost}_referral`;
    }

    return 'direct';
  }

  const detected  = classify();
  const firstTouch = readFirstTouch() || detected;
  storeFirstTouch(firstTouch);
  storeLastTouch(detected);
  const chosen = USE_FIRST_TOUCH ? firstTouch : detected;

  // ---------- STAMPING ----------
  function stamp(u) {
    if (!u) return u;
    const delim = u.includes('?') ? '&' : '?';
    const param = `field:${FORM_FIELD_ID}=${encodeURIComponent(chosen)}`;
    // avoid double-stamping
    if (/(?:\?|&)field:\d+=/i.test(u)) return u;
    return `${u}${delim}${param}`;
  }

  // Buttons/links
  document.querySelectorAll(MAIN_BTN_SELECTOR).forEach(a => {
    const base = a.getAttribute('data-base-url') || a.getAttribute('href');
    if (!base) return;
    a.setAttribute('href', stamp(base));
  });

  // Embedded iframe
  const f = document.querySelector(IFRAME_SELECTOR);
  if (f && f.src && !/(?:\?|&)field:\d+=/i.test(f.src)) f.src = stamp(f.src);

  // Defensive: stamp on click for late-injected nodes (e.g., Acuity embed)
  document.addEventListener('click', function (e) {
    const a = e.target.closest(MAIN_BTN_SELECTOR);
    if (!a) return;
    const h = a.getAttribute('href');
    if (h && !/(?:\?|&)field:\d+=/i.test(h)) a.setAttribute('href', stamp(h));
  }, true);

  // Expose for QA in console
  window.__acuitySource = { detected, firstTouch, lastTouch: readLastTouch(), chosen };
})();
